/** @format */

import iconPdf from 'pages/Home/Main/Report/images/pdf.svg';
import iconXlsx from 'pages/Home/Main/Report/images/xlsx.png';
import iconHtml from 'pages/Home/Main/Report/images/html.svg';

import {ReportFileFormat} from '../types';

const getIcon = (fileFormat: ReportFileFormat): string => {
  switch (fileFormat) {
    case 'pdf':
      return iconPdf;
    case 'xlsx':
      return iconXlsx;
    case 'html':
      return iconHtml;
    default:
      return '';
  }
};

export {getIcon};
